import { Col, Row, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { SignerCommentsView } from "@modules/ContractManagement/SPA/Drilldown/Comments/Components/SignerCommentsView";
import {
  ReviewerCommentsView
} from "@modules/ContractManagement/SPA/Drilldown/Comments/Components/ReviewerCommentsView";
import { permissions } from "@utils/Roles";
import { useHasAccess } from "@hooks/useHasAccess";



interface Props {
  id: any;
  data: any;
  documents: any;
  refreshData?: (value: React.Key[]) => void;
}



export const Comments = ({ id, data, documents }: Props) => {
  const { hasRole } = useHasAccess();

  const itemsAll = [
    {
      label: "Reviewer Comments",
      key: "reviewerComments",
      children: (
        <ReviewerCommentsView />
      ),
    },
    {
      label: "Signer Comments",
      key: "signerComments",
      children: (
        <SignerCommentsView
          data={data} id={id} documents={documents}
        ></SignerCommentsView>
      ),
    },
  ]

  const itemsReviewer = [
    {
      label: "Approver Comments",
      key: "approverComments",
      children: (
        <ReviewerCommentsView />
      ),
    }
  ]
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Tabs
          className="signer-comments"
          defaultActiveKey="approverComments"
          items={itemsReviewer}
        />
      </Col>
    </Row>
  );
};
